/** IoT Manager — grow-room racks (gateway-local). */
export const growRoomRackEndpoints = {
  list: '/v1/iot-manager/grow-room-racks',
  one: (id: string) => `/v1/iot-manager/grow-room-racks/${id}`,
} as const;
